import {BaseAppModel} from "./AppModel";
import {DataType} from "@/module/thing/DataSpec";
import ProductActivation from "./ProductActivation";
import ProductMac from "./ProductMac";
import Product from "@/model/Product";
import DeviceMqtt from "@/model/DeviceMqtt";
import Company from "@/model/Company";
import DeviceHardware from "@/model/DeviceHardware";
import DeviceHardwareStatus from "@/model/DeviceHardwareStatus";
import {SimpleUser} from "@/model/User";
import GuestMqtt from "@/model/GuestMqtt";

export default class Device extends BaseAppModel<Device> {
    sequence!: number
    name!: string
    alias!: string
    key!: string
    mac!: string
    secret!: string
    active!: boolean
    online!: boolean
    bindAt?: string
    bindAtPretty?: string
    bindAddress?: string
    isUpgrading?: boolean
    isTest!: boolean

    product = new Product()
    user = new SimpleUser()
    isBind!: boolean
}

export class DeviceDetail extends Device {
    activeCode!: string
    activeUser = new SimpleUser()

    company? = new Company()
    dmqtt = new DeviceMqtt()
    gmqtt = new GuestMqtt()

    dhardware = new DeviceHardware()
    dhwStatus = new DeviceHardwareStatus()
}

export class DeviceShare extends Device {
    toUser = new SimpleUser()
}

export class DevicePropStatus {
    propName!: string
    propValue!: string
    propIdentifier!: string
    dataType!: DataType
    unitSymbol?: string
    reportTime!: number
}

export class DregisterOptions {
    pmacs = new Array<ProductMac>()
    pacts = new Array<ProductActivation>()
}
